import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap } from 'rxjs/operators';
import { WITHCRED, WithCredNoCache } from "src/app/services/authentication.service";
import { ScrBaseResponse, ScrBaseService, ScrMessage } from "src/app/services/base.service";
import { ScrServiceManager } from "src/app/services/servicemanager.service";
import { ScrEnvironment } from "src/environments/environment";
import { StringOrPhoneNumber } from "../models/common.model";
import { CacheService } from "./cache.service";

export class Address {
  addressBookId?: number;
  address1?: string;
  address2?: string;
  city?: string;
  company?: string;
  country?: string;
  email?: string;
  firstName?: string;
  label?: string;
  lastName?: string;
  phone?: StringOrPhoneNumber;
  phoneExtension?: string;
  state?: string;
  zip?: string;
}

export class AddressBookResponse extends ScrBaseResponse {
  addressBook!: Address;
}

export class AddressBookListResponse extends ScrBaseResponse {
  constructor(status: string, public addressbook: Address[], messages: ScrMessage[]) {
    super(status, messages);
  }
}

@Injectable({
  providedIn: 'root'
})
export class AddressBookService extends ScrBaseService {

  constructor(
    serviceManager: ScrServiceManager,
    private cache: CacheService,
    private environment: ScrEnvironment,
    private http: HttpClient) {
    super(serviceManager);
  }

  getAddresses(clearcache = false): Observable<AddressBookListResponse> {
    if (clearcache) {
      this.cache.invalidate('addressbook');
    }

    const items = this.cache.get<Address[]>('addressbook');
    if (items) {
      return of(new AddressBookListResponse('success', items, []));
    }

    const url = `${this.environment.base}/secure/addressbook`;
    return this.http.get<AddressBookListResponse>(url, WithCredNoCache).pipe(tap(rsp => {
      if ((rsp.status === 'success') && (rsp.addressbook)) {
        this.cache.set('addressbook', rsp.addressbook, 300_000);
      }
    }));
  }

  saveAddress(address: Address): Observable<AddressBookResponse> {
    const url = `${this.environment.base}/secure/addressbook`;
    this.cache.invalidate('addressbook');

    const addr = JSON.stringify(address, ScrBaseService.phoneReplacer);

    if (address.addressBookId)
      return this.http.put<AddressBookResponse>(url, addr, WITHCRED);
    else
      return this.http.post<AddressBookResponse>(url, addr, WITHCRED);
  }

  deleteAddress(address: Address): Observable<AddressBookResponse> {
    this.cache.invalidate('addressbook');
    const url = `${this.environment.base}/secure/addressbook/${address.addressBookId}`;
    return this.http.delete<AddressBookResponse>(url, WITHCRED);
  }

}